import NewHireEditorActionTypes from './new-hire-ref.types';

export const setNewHireEditorDepartment = (department) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_DEPARTMENT,
  payload: department,
});

export const setNewHireEditorPosition = (position) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_POSITION,
  payload: position,
});

export const setNewHireEditorDepartments = (departments) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_DEPARTMENTS,
  payload: departments,
});

export const setNewHireEditorPositions = (positions) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_POSITIONS,
  payload: positions,
});

export const setNewHireEditorLocalDistros = (localDistros) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_LOCAL_DISTROS,
  payload: localDistros,
});

export const setNewHireEditorAzureGroups = (azureGroups) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_AZURE_GROUPS,
  payload: azureGroups,
});

export const setNewHireEditorGoogleGroups = (googleGroups) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_GOOGLE_GROUPS,
  payload: googleGroups,
});

export const setNewHireEditorNoc = (noc) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_NOC,
  payload: noc,
});

export const setNewHireEditorNavitaire = (navitaire) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_NAVITAIRE,
  payload: navitaire,
});

export const setNewHireEditorUber = (uber) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_UBER,
  payload: uber,
});

export const setNewHireEditorLyft = (lyft) => ({
  type: NewHireEditorActionTypes.SET_NEW_HIRE_EDITOR_LYFT,
  payload: lyft,
});

export const getNewHireEditorDataSuccess = (data) => ({
  type: NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_SUCCESS,
  payload: data,
});

export const getNewHireEditorDataFailure = (error) => ({
  type: NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_FAILURE,
  payload: error,
});

export const getNewHireEditorDataStart = () => ({
  type: NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_START,
});
